const theme = {
  colors: {
    // Dark theme with Apple-inspired colors
    primary: '#0A84FF', // Apple blue
    secondary: '#30D158', // Apple green
    background: '#000000', // Black background
    backgroundAlt: '#111111', // Slightly lighter black
    text: '#FFFFFF', // White text
    textSecondary: '#8E8E93', // Light gray text
    borderColor: '#2C2C2E', // Dark gray border
    accent: '#FF375F', // Apple red
    success: '#30D158', // Apple green
    warning: '#FFD60A', // Apple yellow
    error: '#FF453A', // Apple red
    darkBg: '#1E1E1E',
    cardBg: '#1C1C1E',
  },
  fonts: {
    heading: "'Inter', sans-serif",
    body: "'Inter', sans-serif",
  },
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
    '5xl': '3rem',
    '6xl': '3.75rem',
  },
  breakpoints: {
    xs: '480px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
    xxxl: '4rem',
    '2xl': '3rem',
    '3xl': '4rem',
    '4xl': '6rem',
  },
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
  },
  borderRadius: {
    small: '0.125rem',
    medium: '0.375rem',
    sm: '0.125rem',
    md: '0.25rem',
    lg: '0.5rem',
    xl: '1rem',
    full: '9999px',
  },
  transitions: {
    default: 'all 0.3s ease',
    fast: 'all 0.15s ease',
    normal: 'all 0.3s ease', 
    slow: 'all 0.5s ease',
  },
  boxShadow: {
    normal: '0 4px 6px rgba(0, 0, 0, 0.1)',
    elevated: '0 10px 25px rgba(0, 0, 0, 0.2)',
  },
};

export default theme;
